export default "__VITE_ASSET__3c97adc4__"